import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";
import ConfirmationModal from "../../../Controls/ConfirmationModal";


const Dropped = (props) => {

  const { loginData } = useSelector((store) => store.login);
  const { ASCSSettingData, BrokerServingAffiliatesData } = useSelector((store) => store.combinedata);
  const [showDroppedAlert, setDroppedAlert] = useState(false);
  const [droppedAlertObj, setDroppedAlertObj] = useState({ alertTitle: '', alertMsg: '' });
  const [dispatchMethod, setDispatchMethod] = useState(0);
  const [allowableTimeTripActions, setAllowableTimeTripActions] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalBodyText, setModalBodyText] = useState('');


  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    UnMountDroppedComponent()

  };
  const handleOkModal = () => {
    setShowModal(false);
    PerformManualDropped();

  };

  function convertTo24HourFormat(dateStr) {
    try {
      let [date, timeWithPeriod] = dateStr.trim().split(/\s+/);
      let [month, day, year] = date.split('/');
      let [time, period] = timeWithPeriod.split(/(AM|PM)/);

      let [hours, minutes] = time.split(':');
      if (period === "PM" && hours < 12) {
        hours = parseInt(hours) + 12;
      }
      if (period === "AM" && hours == 12) {
        hours = 0;
      }
      hours = hours.toString().padStart(2, '0');
      minutes = minutes.padStart(2, '0');
      let isoFormattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00`;

      return isoFormattedDate;
    } catch (error) {
      console.error("Error: convertTo24HourFormat, " + error);
      return dateStr;
    }

  }
  useEffect(() => {

    if (!props.GridRowData || props.GridRowData.length <= 0) {
      setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'No trip selected', alertMsg: 'No request selected to perform Dopped.' });
      setDroppedAlert(true);
    }
    else {
      const gData = props.GridRowData[0];
      let filteredAffiliates = [];
      try {
        filteredAffiliates = BrokerServingAffiliatesData?.filter(
          (aff) => String(aff.iBrokerAffiliateID) === String(gData.iSRATSPID)
        );
      }
      catch (e) {

      }
      if (filteredAffiliates?.length > 0) {
        setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'Action Restriction', alertMsg: `The trip is assigned to an Affiliate (${gData.Affiliate}) and only Affiliate can initiate this action.` });
        setDroppedAlert(true);
      }
      else if (gData.iServiceStatusID !== "3") {
        setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'Invalid Action', alertMsg: "Action not allowed on un-dispatched trip." });
        setDroppedAlert(true);
      }
      else if (gData.TripRequestStatus.toLowerCase() === "cancelled") {
        setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'Invalid Action', alertMsg: "Cannot perform Dropped action on 'CANCELLED' trip." });
        setDroppedAlert(true);
      }
      else if (gData.TripRequestStatus.toLowerCase() === "pickedup") {
        if (ASCSSettingData !== null && ASCSSettingData !== undefined) {
          if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
            const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
            for (let i = 0; i < ascsSettingDataByAffiliate.length; i++) {
              if (ascsSettingDataByAffiliate[i]["SubTitle"] === "DispatchMethod") {
                setDispatchMethod(ascsSettingDataByAffiliate[i]["value"]);
              }
              if (ascsSettingDataByAffiliate[i]["SubTitle"] === "AllowableTimeTripActions") {
                setAllowableTimeTripActions(ascsSettingDataByAffiliate[i]["value"]);
              }
            }
          }
        }
        const pickupDateTimeStr = props.GridRowData?.[0]?.PickupDateTime;
        if (!pickupDateTimeStr) {
          setDroppedAlertObj(droppedAlertObj => ({ ...droppedAlertObj, alertTitle: 'PickedUp DateTime Missing', alertMsg: "Action failed." }));
          setDroppedAlert(true);
          console.error("Error: PickupDateTime is missing.");
          return;
        }

        let isoDateString = convertTo24HourFormat(pickupDateTimeStr);
        let _pickUpDateTimeObj = new Date(isoDateString);

        if (isNaN(_pickUpDateTimeObj.getTime())) {
          console.error("Error: Invalid pickup date.");
          handleShowModal();
          return;
        }
        _pickUpDateTimeObj.setMinutes(_pickUpDateTimeObj.getMinutes() - parseInt(allowableTimeTripActions, 10));

        let minimumPickDateTimeObj = new Date(_pickUpDateTimeObj)
        let currentDateTime = new Date();

        let timeDifference = currentDateTime - minimumPickDateTimeObj
        let differenceInMinutes = Math.floor(Math.abs(timeDifference) / (1000 * 60));

        if (currentDateTime < minimumPickDateTimeObj) {
          let message = ''
          if (differenceInMinutes > 60) {
            let hours = Math.floor(differenceInMinutes / 60);
            let minutes = differenceInMinutes % 60;
            message = `This trip is scheduled to be picked-up in over ${hours} hours and ${minutes} minutes. Marking it as 'Dropped' seems too early. Do you want to continue?`;
          } else {
            message = `This trip is scheduled to be picked-up in over ${differenceInMinutes} minutes. Marking it as 'Dropped' seems too early. Do you want to continue?`;
          }
          setModalBodyText(message)
          handleShowModal()
        } else {
          PerformManualDropped()
        }
      }
      else {
        setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'Action Restriction', alertMsg: "'" + gData.ConfirmationNo + "' cannot be marked as Dropped. Trip state is not PICKEDUP." });
        setDroppedAlert(true);
      }


    }

  }, [props.GridRowData, BrokerServingAffiliatesData, ASCSSettingData]);


  const PerformManualDropped = async () => {
    const gData = props.GridRowData[0];
    var Param = {
      "iServiceID": gData.ServiceID,
      "DispatchedBy": dispatchMethod,
      "iRefID": gData.ConfirmationNo,
      "iUserID": loginData.iUserID
    }
    let response = await APICom.fetchData("", "TripActions/PerformManualDropped", "post", { "Content-Type": "application/json" }, Param, null);
    let result = response.data;
    if (result.count > 0) {
      setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'Dropped Action', alertMsg: "Action performed successfully." });
      setDroppedAlert(true);
      props.GridRowData[0].TripRequestStatus = 'DROPPED'
    }
    else {
      setDroppedAlertObj({ ...droppedAlertObj, alertTitle: 'Dropped Failed', alertMsg: "Action failed." });
      setDroppedAlert(true);
    }
    props.ReloadDataFunction();
  }

  const handleDroppedAlertClose = () => {
    setDroppedAlert(false);
    UnMountDroppedComponent();
  }

  const UnMountDroppedComponent = () => {
    if (props.droppedComponentLoaded) {
      props.setDroppedProcessing(false);
      props.setDroppedComponentLoad(false);
    }
  }

  return (
    <>
      {showDroppedAlert && <Modal centered show={showDroppedAlert} onHide={handleDroppedAlertClose} animation={false} >
        <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
          <Modal.Title className='activate_dialog_title_color'>{droppedAlertObj.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{droppedAlertObj.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDroppedAlertClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>}
      {showModal ? <ConfirmationModal show={true} Title={'Mark Dropped Warning'} Body={modalBodyText} btnCanceText={'Cancel'} btnOkText={'Mark Dropped'} ShowCancelButton={true} onOk={handleOkModal} onCancel={handleCloseModal} /> : ""}
    </>
  );
};


export default Dropped;